<template>
	<section id="intro" class="main-content">
		<div class="row">
			<slot name="content">
				<div class="columns column12 align-center">
					<h4 v-if="subtitle" class="subtitle">{{ subtitle }}</h4>
					<h1>{{ title }}</h1>
					<div v-parse-links v-html="content" />
				</div>
			</slot>
			<slot name="right-content">
				<div v-if="rightContent" v-parse-links class="columns column6" v-html="rightContent" />
			</slot>
			<slot />
		</div>
		<slot name="extra-content" />
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	content: { type: String, default: '' },
	rightContent: { type: String, default: '' },
});
</script>

<style scoped>
.column12 {
	max-width: 900px;
	margin: 0 auto;
}

@media (max-width: 960px) {
	.column6 {
		padding: 25px;
	}
}
</style>
